import { ButtonProps, Link } from '@chakra-ui/react';
import Button from '~/components/Button';
import { ContactIcon } from '~/components/icons';

import { whiteButtonStyles } from '../../ButtonsSection.styles';

interface Props extends ButtonProps {
  email: string;
}

export const ContactButton: React.FC<Props> = ({ email, ...props }) => (
  <Link href={`mailto:${email}`} _hover={{ textDecoration: 'none' }}>
    <Button {...props} {...whiteButtonStyles} leftIcon={<ContactIcon />}>
      Contact
    </Button>
  </Link>
);
